const management = [
  {
    path: 'text-pages',
    name: 'textpages',
    icon: 'cil-speech',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'text-pages'
    },
    children: [
      {
        path: '',
        name: 'textpages_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/textpage/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin']
        }
      },
      {
        path: 'new',
        name: 'text_page_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/textpage/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin']
        }
      },
      {
        path: ':id',
        name: 'textpage',
        components: {
          content: () => import('@/views/pages/textpage/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin']
        }
      }
    ]
  },

  {
    path: 'sliders',
    name: 'sliders',
    icon: 'cil-task',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'sliders'
    },
    children: [
      {
        path: '',
        name: 'sliders_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/slider/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin']
        }
      },
      {
        path: 'new',
        name: 'slider_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/slider/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin']
        }
      },
      {
        path: ':id',
        name: 'slider',
        components: {
          content: () => import('@/views/pages/slider/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin']
        }
      }
    ]
  },

  {
    path: 'news-feeds',
    name: 'news_feed',
    icon: 'cil-chat-bubble',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'news-feed'
    },
    children: [
      {
        path: '',
        name: 'news_feed_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/news_feed/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'news-feed'
        }
      },
      {
        path: 'new',
        name: 'news_feed_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/news_feed/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'news-feed'
        }
      },
      {
        path: ':id',
        name: 'news_feed_edit',
        components: {
          content: () => import('@/views/pages/news_feed/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'news-feed'
        }
      }
    ]
  },

  {
    path: 'menus',
    name: 'frontend_menu',
    icon: 'cil-menu',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'frontend-menu'
    },
    children: [
      {
        path: '',
        name: 'frontend_menu_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/frontend_menu/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin']
        }
      }
    ]
  },

  {
    path: 'media-pages',
    name: 'mediapages',
    icon: 'cil-speech',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'media'
    },
    children: [
      {
        path: '',
        name: 'mediapages_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/mediapage/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'media'
        }
      },
      {
        path: 'media-files',
        name: 'mediapages_file_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/mediapage/FileList.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'media'
        }
      },
      {
        path: 'new',
        name: 'media_page_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/mediapage/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'media'
        }
      },
      {
        path: ':id',
        name: 'mediapage',
        components: {
          content: () => import('@/views/pages/mediapage/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'media'
        }
      }
    ]
  },

  {
    path: 'default-banners',
    name: 'default_banners',
    icon: 'cil-spreadsheet',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/banners/List.vue')
    },
    meta: {
      requiredRole: ['admin'],
      moduleSlug: 'default-banners'
    }
  },

  {
    path: 'prices',
    name: 'prices',
    icon: 'cib-product-hunt',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'prices'
    },
    children: [
      {
        path: '',
        name: 'prices_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/price/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'prices'
        }
      },
      {
        path: ':id',
        name: 'price',
        components: {
          content: () => import('@/views/pages/price/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'prices'
        }
      },

      {
        path: 'new',
        name: 'price_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/price/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'prices'
        }
      }
    ]
  },

  {
    path: 'price-categories',
    name: 'price_categories',
    icon: 'cib-product-hunt',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'price-categories'
    },
    children: [
      {
        path: '',
        name: 'price_categories_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/price_categories/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'price-categories'
        }
      },
      {
        path: ':id',
        name: 'price_category',
        components: {
          content: () => import('@/views/pages/price_categories/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'price-categories'
        }
      },

      {
        path: 'new',
        name: 'price_categories_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/price_categories/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'price-categories'
        }
      }
    ]
  },

  {
    path: 'brochure-prices',
    name: 'brochure_prices',
    icon: 'cib-product-hunt',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'brochure-prices'
    },
    children: [
      {
        path: '',
        name: 'brochure_prices_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/brochure_prices/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'brochure-prices'
        }
      },
      {
        path: ':id',
        name: 'brochure_price',
        components: {
          content: () => import('@/views/pages/brochure_prices/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'brochure-prices'
        }
      },
      {
        path: 'brochure-files',
        name: 'brochure_file_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/brochure_prices/FileList.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'brochure-prices'
        }
      },
      {
        path: 'new',
        name: 'brochure_prices_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/brochure_prices/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'brochure-prices'
        }
      }
    ]
  },

  {
    path: 'main-boxes',
    name: 'main_boxes',
    icon: 'cib-product-hunt',
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
      moduleSlug: 'main-boxes'
    },
    children: [
      {
        path: '',
        name: 'main_boxes_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/main_boxes/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'main-boxes'
        }
      },
      {
        path: ':id',
        name: 'main_box',
        components: {
          content: () => import('@/views/pages/main_boxes/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'main-boxes'
        }
      },

      {
        path: 'new',
        name: 'main_boxes_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/main_boxes/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'main-boxes'
        }
      }
    ]
  },

  {
    path: 'hello-customer-survey',
    name: 'hello-customer-survey',
    icon: 'cil-short-text',
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
      moduleSlug: 'surveys'
    },
    children: [
      {
        path: '',
        name: 'surveys_list',
        icon: 'cil-short-text',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/hello-customer-surveys/List.vue')
        },
        meta: {
          requiredRole: ['admin'],
          moduleSlug: 'surveys'
        }
      },

      {
        path: 'new',
        name: 'survey_new',
        icon: 'cil-short-text',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/hello-customer-surveys/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'surveys'
        }
      },
      {
        path: ':id',
        name: 'survey',
        components: {
          content: () => import('@/views/pages/hello-customer-surveys/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'surveys'
        }
      }
    ]
  },

  {
    path: 'about-list',
    name: 'about',
    icon: 'cil-speech',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'about'
    },
    children: [
      {
        path: '',
        name: 'about_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/about/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'about'
        }
      },
      {
        path: 'new',
        name: 'about_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/about/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'about'
        }
      },
      {
        path: ':id',
        name: 'about_edit',
        components: {
          content: () => import('@/views/pages/about/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'about'
        }
      }
    ]
  },
  {
    path: 'contact-service',
    name: 'contact_service',
    icon: 'cil-speech',
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
      moduleSlug: 'contact-service'
    },
    children: [
      {
        path: '',
        name: 'contact_service_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/contact_service/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'contact-service'
        }
      },
      {
        path: 'new',
        name: 'contact_service_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/contact_service/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'contact-service'
        }
      },
      {
        path: ':id',
        name: 'contact_service_edit',
        components: {
          content: () => import('@/views/pages/contact_service/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'contact-service'
        }
      },
      {
        path: 'description',
        name: 'contact_service_description_list',
        components: {
          content: () => import('@/views/pages/contact_service/DescriptionList.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'contact-service'
        }
      },

      {
        path: 'description/new',
        name: 'contact_service_description_new',
        components: {
          content: () => import('@/views/pages/contact_service/NewDescription.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'contact-service'
        }
      },

      {
        path: 'description/:id',
        name: 'contact_service_description_edit',
        components: {
          content: () => import('@/views/pages/contact_service/EditDescription.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'contact-service'
        }
      }
    ]
  },
  {
    path: 'promotions-list',
    name: 'promotions',
    icon: 'cil-speech',
    meta: {
      requiredRole: ['admin'],
      moduleSlug: 'sales-promotions'
    },
    children: [
      {
        path: '',
        name: 'promotions_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/promotions/List.vue')
        },
        meta: {
          requiredRole: ['admin'],
          moduleSlug: 'sales-promotions'
        }
      },
      {
        path: 'new',
        name: 'promotions_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/promotions/New.vue')
        },
        meta: {
          requiredRole: ['admin'],
          moduleSlug: 'sales-promotions'
        }
      },
      {
        path: ':id',
        name: 'promotions_edit',
        components: {
          content: () => import('@/views/pages/promotions/Edit.vue')
        },
        meta: {
          requiredRole: ['admin'],
          moduleSlug: 'sales-promotions'
        }
      }
    ]
  },
  {
    path: 'campaigns-list',
    name: 'campaigns',
    icon: 'cil-speech',
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
      moduleSlug: 'campaigns'
    },
    children: [
      {
        path: '',
        name: 'campaigns_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/campaigns/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'campaigns'
        }
      },
      {
        path: 'new',
        name: 'campaigns_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/campaigns/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'campaigns'
        }
      },
      {
        path: ':id',
        name: 'campaigns_edit',
        components: {
          content: () => import('@/views/pages/campaigns/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'campaigns'
        }
      }
    ]
  },

  {
    path: 'marketing-consents',
    name: 'marketing_consents',
    icon: 'cil-check-circle',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
      moduleSlug: 'marketing-consents'
    },
    children: [
      {
        path: '',
        name: 'marketing_consents_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/marketing-consents/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'marketing-consents'
        }
      },
      {
        path: ':id',
        name: 'marketing_consents_edit',
        components: {
          content: () => import('@/views/pages/marketing-consents/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'marketing-consents'
        }
      }
    ]
  }
]

export default management
